<template>
  <div class="landing">
    <LandingNavigation />

    <BackgroundWavy />

    <section class="banner">
      <div class="left">
        <h1>
          Grow your <br />
          <span class="underline-white-bg">
            <span>legal team</span>
          </span>
          right.
        </h1>
        <h2>
          Manage your clients, contracts, cases, and office.
        </h2>
        <p class="lead mb-0">Help your team get on the same page.</p>
        <p class="lead mt-0">Made for law firms & legal teams.</p>

        <div class="actions">
          <!-- <button class="btn btn-primary">Sign up</button> -->
          <button
            class="request-demo"
            @click="
              $intercom.showNewMessage(`Hi there. I'd like to request a demo.`)
            "
          >
            Request Demo
          </button>
        </div>
        <div class="trusted-by d-none d-md-block">
          <p class="text-muted">
            Trusted by some of the most exciting legal teams in the world.
          </p>
        </div>
      </div>
      <div class="right">
        <div class="highlights">
          <img
            :src="highlights[randomIndex].screenshot"
            :alt="highlights[randomIndex].tagline"
            class="pointer"
            width="370px"
            @click="
              $router.push(
                `/features/${
                  highlights[randomIndex].alias
                }#${getHighlightHashUrl(highlights[randomIndex].tagline)}`
              )
            "
          />
        </div>
      </div>
    </section>
    <section class="features full-width-div">
      <div class="container">
        <div class="col-sm-12 col-md-6">
          <p class="uppercase">Your platform to success</p>
          <h1>Product Features</h1>
          <p class="lead" style="margin-bottom: 0">
            Explore the tools we’ve designed specifically to help you increase
            your
            <span class="underline">legal teams</span>
            productivity.
          </p>
        </div>
        <div class="d-sm-none d-none d-md-block col-sm-6">
          <div class="buttons float-right">
            <!-- <button class="btn btn-primary">Sign up</button> -->
            <button
              class="btn btn-white"
              @click="
                $intercom.showNewMessage(
                  `Hi there. I'd like to request a demo.`
                )
              "
            >
              Request Demo
            </button>
          </div>
        </div>
      </div>

      <div class="feature-cards-large">
        <FeatureCard
          v-for="(feature, index) in features['legal'].slice(0, 5)"
          :key="index"
          :feature="feature"
          :enable-linking="true"
        />
      </div>

      <div class="feature-cards-small">
        <FeatureCard
          v-for="(feature, index) in features['legal'].slice(0, 3)"
          :key="index"
          :feature="feature"
          :enable-linking="true"
        />
      </div>

      <div class="feature-action">
        <router-link tag="button" class="learn-more" to="/features"
          >See all features</router-link
        >
      </div>

      <Footer />
    </section>
  </div>
</template>

<script>
import features from "./features";
import FeatureCard from "./FeatureCard.vue";
import Footer from "./Footer.vue";
import LandingNavigation from "./LandingNavigation";
import BackgroundWavy from "./BackgroundWavy.vue";

// import $ from "jquery";
import _ from "lodash";

export default {
  data() {
    return {
      features,
      highlights: null,
      randomIndex: null
    };
  },

  components: {
    BackgroundWavy,
    FeatureCard,
    Footer,
    LandingNavigation
  },

  created() {
    this.highlights = _.uniq(
      _.flattenDeep(
        features["legal"].map(feature => {
          if (feature.highlights) {
            return feature.highlights.map(highlight => {
              return {
                alias: feature.alias,
                ...highlight
              };
            });
          }
        })
      )
    );

    this.randomIndex = this.generateRandomNum(0, this.highlights.length - 1);
  },

  methods: {
    generateRandomNum(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    getHighlightHashUrl(title) {
      return title
        .toLowerCase()
        .replace(/\./g, "")
        .split(" ")
        .join("-");
    },

    getNextToRandomIndex(random) {
      return this.highlights.length - 1 === random ? 0 : random + 1;
    }
  }
};
</script>

<style lang="scss" scoped>
$num-cards: 5;

.landing {
  section.banner {
    display: grid;
    grid-template-columns: 50% auto;
    margin-top: 20vh;
    position: relative;

    .left {
      h1 {
        font-size: 60px;
        font-weight: 700;
      }

      #selectIndustry {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        border: none;
        box-shadow: none;
        padding: 0;
        margin: 0;
        /* needed for Firefox: */
        overflow: hidden;
        background: none;

        // style the same as the h1
        font-size: 60px;
        font-weight: 700;

        width: 275px;

        &.wider {
          width: 405px;
        }

        &:focus {
          outline: 0;
        }
      }

      p.lead {
        margin: 0 0 50px;
      }

      .actions {
        margin: 0 0 100px;
      }
    }

    .right {
      .highlights {
        position: absolute;
        top: -50px;
        left: 60%;
        width: 1000px;
      }
    }
  }

  section.features {
    background: #f2f5ff;
    margin-top: 200px;
    position: absolute;
    width: 100%;
    overflow: hidden;

    &:after {
      content: "";
      width: 100%;
      height: 100%;
      background: #f2f5ff;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }

    .container {
      display: flex;
      align-items: flex-end;
      padding: 100px 0;

      h1 {
        font-weight: 600;
      }

      .uppercase {
        font-size: 13px;
        letter-spacing: 1px;
        font-weight: 400;
      }
    }

    .feature-action {
      display: flex;
      justify-content: center;
    }

    .feature-cards-small {
      display: none;
    }

    .feature-cards-large {
      display: none;
      position: relative;
      padding: 0;
      height: 500px;
      width: $num-cards * 400px;
      justify-content: center;
      align-items: center;
      left: 50vw;
      margin-left: -200px; // half width of feature-card

      $one-step: 100 / $num-cards;

      -moz-animation: carousel #{$num-cards * 5}s infinite;
      -webkit-animation: carousel #{$num-cards * 5}s infinite;
      animation: carousel #{$num-cards * 5}s infinite;

      // animation strategy: start (0%) and end animation (100%) at 50vw
      // in each step increase left by 50vw - (i * sizeOfCard)
      @keyframes carousel {
        0% {
          left: 50vw;
        }

        // add steps in between 0% and 100%
        @for $i from 1 through $num-cards - 1 {
          #{$i * $one-step}% {
            left: calc(50vw - calc(#{$i} * 400px));
          }
        }

        100% {
          left: 50vw;
        }
      }

      &:hover {
        -webkit-animation-play-state: paused;
        -moz-animation-play-state: paused;
        -o-animation-play-state: paused;
        animation-play-state: paused;
      }
    }
  }

  // MOBILE/TABLET VIEW
  @media (min-width: 0) and (max-width: 768px) {
    section.features {
      .feature-cards-small {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .feature-action {
        margin-top: 50px;
      }
    }
  }

  // DESKTOP VIEW
  @media (min-width: 769px) {
    section.features {
      .feature-cards-large {
        display: flex;
      }

      .feature-action {
        margin-top: 120px;
      }
    }
  }

  // mobile & tablet strategy
  @media (max-width: 992px) {
    section.banner {
      grid-template-columns: 100%;
      margin-top: 10px;
      text-align: center;

      .right {
        display: none;
      }

      h1 {
        font-size: 30px;
      }
    }

    section.features {
      margin-top: 20px;
    }
  }
}
</style>
